import { render, staticRenderFns } from "./FavoriteList.vue?vue&type=template&id=46cc92a8&scoped=true"
import script from "./FavoriteList.vue?vue&type=script&lang=js"
export * from "./FavoriteList.vue?vue&type=script&lang=js"
import style0 from "./FavoriteList.vue?vue&type=style&index=0&id=46cc92a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc92a8",
  null
  
)

export default component.exports